<!-- <router-outlet></router-outlet> -->
<app-header class="lang-{{currLang}}" *ngIf="!hideHeaderFooter && !isIntl" ></app-header>
<app-header-intl *ngIf="!hideHeaderFooter && isIntl" ></app-header-intl>

<div class="mainContainer  lang-{{currLang}}">
  <section class="web_homePage loadingHeight" (scroll)="onWindowScroll($event);">
    <router-outlet></router-outlet>
    <!-- <app-chat-bot *ngIf="!isIntl"></app-chat-bot> -->
  </section>
  </div>
<app-footer  class="lang-{{currLang}}" *ngIf="!hideHeaderFooter && !isIntl"></app-footer>
<app-footer-intl *ngIf="!hideHeaderFooter && isIntl"></app-footer-intl>
